module.exports = __webpack_public_path__ + "media/images/curriculum_title_image-4ebab4acee167aa0a1197b272261e38b.png";